import { createSlice } from "@reduxjs/toolkit";


export const accessoiresSlice = createSlice({
    name: 'accessoires',
    initialState:{},
    reducers: { //modify the selected spot in global state
        

        newAccess: (currentState, action) => {
            
            let newAccessList = currentState;

            newAccessList.push({id_article:action.payload.id_article,qte:1})

            return newAccessList
        },

        refillAccess: (currentState, action) => { // refill redux from db (edit contrat)
            
            let newAccessList = currentState;

            newAccessList.push({id_article:action.payload.id_article,qte:action.payload.qte})

            return newAccessList
        },
        removeAccess: (currentState, action) => {
            
            let accessId=action.payload.id_article;
            let newAccessList = currentState.filter((ligne)=>ligne.id_article!==accessId);
            return newAccessList
        },

        incrementAccess: (currentState, action) => {
            
            let accessId=action.payload.id_article;
            const newAccessList = currentState.map((item) =>
                item.id_article === accessId
                ? { ...item,
                    qte : item.qte+1
                }
                : item
            )
            
            return newAccessList 
        },

        decrementAccess: (currentState, action) => {
            
            let accessId=action.payload.id_article;
            const newAccessList = currentState.map((item) =>
                item.id_article === accessId
                ? { ...item,
                    qte : item.qte-1
                }
                : item
            )
            
            return newAccessList 
        },
        resetPanier: (currentState, action) => {
            return [];
        }
       
    }
});